import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import BreadcrumbsDispatcher from '@scandipwa/scandipwa/src/store/Breadcrumbs/Breadcrumbs.dispatcher';
import { updateMeta } from '@scandipwa/scandipwa/src/store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { NavigationType } from 'Store/Navigation/Navigation.type';
import ColoredDiamondCategoryPage from './ColoredDiamondCategoryPage.component';
import { fetchQuery } from '@scandipwa/scandipwa/src/util/Request/Query';
import ColoredDiamond from 'Query/ColoredDiamond.query';
import { getQueryParam } from '@scandipwa/scandipwa/src/util/Url';
import history from '@scandipwa/scandipwa/src/util/History';
import { prepareQuery } from '@scandipwa/scandipwa/src/util/Query';
import { executeGet, listenForBroadCast } from '@scandipwa/scandipwa/src/util/Request/Request';
import { makeCancelable } from '@scandipwa/scandipwa/src/util/Promise';
import { hash } from '@scandipwa/scandipwa/src/util/Request/Hash';

/** @namespace Route/CmsPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
});

/** @namespace Route/CmsPage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateBreadcrumbs: (breadcrumbs) => BreadcrumbsDispatcher.update(breadcrumbs, dispatch),
    updateMeta: (meta) => dispatch(updateMeta(meta)),
    setHeaderState: (stateName) => dispatch(changeNavigationState(NavigationType.TOP_NAVIGATION_TYPE, stateName)),
});

export class ColoredDiamondCategoryPageContainer extends PureComponent {
    static propTypes = {
        device: this.propTypes,
        updateBreadcrumbs: this.propTypes,
        updateMeta: this.propTypes,
        setHeaderState: this.propTypes
    }

    state = {
        diamond: {},
        pageSize: 48,
        currentPage: 1,
        isLoading: true,
        isDiamondLoade: false
    }

    containerFunctions = {
        // fetchColorDiamond: this.fetchColorDiamond.bind(this)
    };

    constructor(props) {
        super(props);

        this.diamondObserving = this.diamondObserving.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.updateBreadcrumbs();
        this.uppdateMeta();
        this.updateHeader();

        this.fetchColorDiamond();

        window.addEventListener('scroll', this.diamondObserving);
    }

    componentDidUpdate() {
        this.updateBreadcrumbs();
        this.uppdateMeta();
        this.updateHeader();

        window.addEventListener('scroll', this.diamondObserving);
    }

    componentWillUnmount() {
        window.isPrefetchValueUsed = false;

        window.addEventListener('scroll', this.diamondObserving);
    }

    updateBreadcrumbs() {
        const { updateBreadcrumbs } = this.props;

        const breadcrumbs = [
            {
                url: '/coloreddiamond',
                name: 'Colored Diamonds',
            },
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    uppdateMeta() {
        const { updateMeta } = this.props;

        updateMeta({
            title: "Colored Diamonds",
            description: "Colored Diamonds",
            keywords: "Colored Diamonds",
            canonical_url: '/coloreddiamond',
        });
    }

    updateHeader() {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: "Colored Diamonds",
            title: "Colored Diamonds",
        });
    }

    fetchData(
        rawQueries,
        onSuccess,
        onError,
        takeFromWindowCache = true,
    ) {
        const preparedQuery = prepareQuery(rawQueries);
        const { query, variables } = preparedQuery;
        const queryHash = hash(query + JSON.stringify(variables));

        if (!window.dataCache) {
            window.dataCache = {};
        }

        if (takeFromWindowCache && window.dataCache[queryHash]) {
            onSuccess(window.dataCache[queryHash]);

            return;
        }

        this.promise = makeCancelable(
            executeGet(preparedQuery, this.dataModelName, this.cacheTTL),
        );

        this.promise.promise.then(
            /** @namespace Util/Request/DataContainer/DataContainer/fetchData/then */
            (response) => {
                (window.dataCache || {})[queryHash] = response;
                onSuccess(response);
            },
            /** @namespace Util/Request/DataContainer/DataContainer/fetchData/then/onError/catch */
            (err) => onError(err),
        );

        if (this.isShouldListenForBroadcast) {
            listenForBroadCast(this.dataModelName).then(
                /** @namespace Util/Request/DataContainer/DataContainer/fetchData/listenForBroadCast/then/onSuccess */
                onSuccess,
            );
        }
    }

    diamondObserving = () => {
        if (window.innerHeight + document.documentElement.scrollTop > document.documentElement.offsetHeight - 1000) {
            const { diamond, currentPage, isDiamondLoade } = this.state;

            if (diamond?.product?.length > 0 && currentPage < diamond?.total_pages && !isDiamondLoade) {
                this.setState({
                    currentPage: currentPage + 1
                });

                this.fetchColorDiamond();
            }
        }
    }

    fetchColorDiamond = () => {
        this.setState({
            isLoading: true,
            isDiamondLoade: true
        });

        const { diamond, currentPage, pageSize } = this.state;

        const location = history.location;

        const fancy_color_intensity = getQueryParam('fancy_color_intensity', location || '');
        const fancy_color_dominant_color = getQueryParam('fancy_color_dominant_color', location || '');
        const diamond_shape = getQueryParam("shape", location || '');
        const diamond_created_from = getQueryParam("diamond_created_from", location || '');

        const carat = getQueryParam('carat', location || '');
        const price = getQueryParam('price', location || '');

        let caratvalue = {};
        let pricevalue = {};

        if (carat) {
            caratvalue = {
                min_carat: carat.split("_")[0],
                max_carat: carat.split("_")[1],
            }
        }

        if (price) {
            pricevalue = {
                min_price: price.split("_")[0],
                max_price: price.split("_")[1],
            }
        }

        const filter = {
            otherFilter: {
                ...(fancy_color_intensity && { fancy_color_intensity: fancy_color_intensity }),
                ...(fancy_color_dominant_color && { fancy_color_dominant_color: fancy_color_dominant_color }),
                ...(diamond_shape && { diamond_shape: diamond_shape }),
                ...(diamond_created_from ? { diamond_created_from: diamond_created_from } : { diamond_created_from: "11" }),
            },
            price: pricevalue,
            carat: caratvalue,
            pageSize,
            currentPage
        }

        if (history.location.pathname.includes("coloreddiamond")) {
            this.fetchData(
                [ColoredDiamond.getQuery(filter)],
                ({ getColorDiamondsByFilter }) => {
                    try {
                        if (currentPage === 1) {
                            this.setState({
                                diamond: getColorDiamondsByFilter,
                                isLoading: false,
                                isDiamondLoade: false
                            });
                        } else {
                            this.setState({
                                diamond: {
                                    ...diamond,
                                    product: [...diamond?.product, ...getColorDiamondsByFilter?.product],
                                    total_items: getColorDiamondsByFilter.total_items,
                                    total_pages: getColorDiamondsByFilter.total_pages
                                },
                                isLoading: false,
                                isDiamondLoade: false
                            })
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            );
        }        
    }

    containerProps() {
        const { device } = this.props;
        const { diamond, isLoading } = this.state;

        return {
            device,
            diamond,
            isLoading,
            fetchColorDiamond: this.fetchColorDiamond
        };
    }

    render() {
        return (
            <ColoredDiamondCategoryPage
                {...this.containerFunctions}
                {...this.containerProps()}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ColoredDiamondCategoryPageContainer);
